import {
  animate,
  keyframes,
  state,
  style,
  transition,
  trigger
} from "@angular/animations";

const ANIMATION_TIME_MS = 250;

export const treeAnimations = [
  trigger("treeLinkInOut", [
    transition(
      "void <=> added",
      animate(
        ANIMATION_TIME_MS,
        keyframes([
          style({ height: 0, overflowY: "hidden", width: 0 }),
          style({ height: "*", width: 0 }),
          style({ height: "*", width: "*" })
        ])
      )
    )
  ]),
  trigger("treeNodeInOut", [
    state("void", style({ width: 0, opacity: 0, padding: 0 })),
    state("added", style({ width: "*", opacity: "*", padding: "*" })),
    transition(
      "void <=> added",
      animate(`${ANIMATION_TIME_MS}ms ${ANIMATION_TIME_MS}ms`)
    )
  ]),
  trigger("glowOnAppear", [
    transition("void => added", [
      animate(
        `${ANIMATION_TIME_MS * 3}ms ${ANIMATION_TIME_MS * 2}ms`,
        keyframes([
          style({ borderColor: "transparent" }),
          style({ borderColor: "rgb(121, 172, 72)" }),
          style({ borderColor: "transparent" })
        ])
      )
    ])
  ]),
  trigger("growInOut", [
    state("open", style({height: "*"})),
    state("collapsed", style({height: "0", overflowY: "hidden"})),
    transition(
      "open <=> collapsed",
      animate(`${ANIMATION_TIME_MS * 2}ms ${ANIMATION_TIME_MS * 2}ms`)
    )
  ]),
  trigger("rotate180", [
    state("false", style({transform: "rotate(0)"})),
    state("true", style({transform: "rotate(-180deg)"})),
    transition(
      "false <=> true",
      animate(`${ANIMATION_TIME_MS}ms ${ANIMATION_TIME_MS}ms`)
    )
  ]),
  trigger("growInOutHorizontal", [
    state("void", style({ width: 0, overflowX: "hidden"})),
    state("*", style({ width: "*"})),
    transition(
      "void <=> *",
      animate(`${ANIMATION_TIME_MS}ms ${ANIMATION_TIME_MS * 2}ms`)
    )
  ])
];
